import React, { useState, useEffect } from 'react'
import LoginBase from './SigninBase'
import { Link } from 'react-router-dom'
import Api from './Services/ApiCall';

export default function Privacy_policy() {


    const [place, setLocation] = useState("");
    const [companyname, setCompanyname] = useState("");
    const [emailid1, setEmailid] = useState("");
    const [contactnumber, setContactnumber] = useState("");
    useEffect(() => {
        CompanyGet()
    }, []);


    async function CompanyGet(id) {
        var Param = { Mstcompanyprofileid: 3 }
        var url = "/Company/BindCompany";
        let _response = await Api.BindGrid(Param, url)

        setCompanyname(_response[0].Companyname);
        setLocation(_response[0].Location);
        setEmailid(_response[0].Emailid);
        setContactnumber(_response[0].Phonenumber);

    }


    return (
        <div>
            <LoginBase />
            <div style={{ padding: '5%', borderRadius: '5px' }}>
                <h2 style={{ textAlign: 'center', color: 'blue' }}>Elakiyaa Best Jobs</h2>
                <p>
                    <div>
                        <span style={{ fontWeight: 'Bold' }}>WHAT DO WE DO WITH YOUR INFORMATION?:</span>
                    </div>
                    <div>
                        When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address.
                        When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.
                        Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>1)CONSENT:</span>
                    </div>
                    <div>
                        How do you get my consent?
                        When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.
                        If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.
                        How do I withdraw my consent?
                        If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at <span style={{ fontWeight: 'Bold' }}>{emailid1} </span> or mailing us at: <span style={{ fontWeight: 'Bold' }}>{place} </span>
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>2)DISCLOSURE:</span>
                    </div>
                    <div>
                        We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>3)PAYMENT:</span>
                    </div>
                    <div>
                        We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.
                        Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.
                        PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.
                        For more insight, you may also want to read terms and conditions of razorpay on https://razorpay.com
                    </div>


                    <div>
                        <span style={{ fontWeight: 'Bold' }}>4)THIRD-PARTY SERVICES:</span>
                    </div>
                    <div>
                        In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.
                        However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.
                        For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.
                        In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.
                        Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.
                        Links
                        When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.

                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>5)SECURITY:</span>
                    </div>
                    <div>
                        To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>6)COOKIES:</span>
                    </div>
                    <div>
                        We use cookies to maintain session of your user. It is not used to personally identify you on other websites.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>7)AGE OF CONSENT:</span>
                    </div>
                    <div>
                        By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>8)CHANGES TO THIS PRIVACY POLICY:</span>
                    </div>
                    <div>
                        We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
                        If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>9)REGISTRATION DATA:</span>
                    </div>
                    <div>
                        is defined as all the information and particulars of the Member requested on initial application and subscription, including but without limiting to the Member's name, mailing address, email address, account and telephone number. The words can be used either in the singular or plural sense and those implying one gender shall also include the other.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>10)RATES:</span>
                    </div>
                    <div>
                        The subscription rates for the Services shall be at the price indicated in the Rate Card or the Company may prescribe such other rates from time to time. Liability for the Subscription Fees shall accrue from the Date of Activation.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>11)Data security:</span>
                    </div>
                    <div>
                        We take precautions to protect your data and to prevent abuse from the outside. It uses measures such as encryption (SSL encryption), firewalls, hacker defense programs and manual security measures. SSL encryption is active when the key icon at the bottom of your browser is closed and when the address starts with "https: //".
                        Data transfer is then protected by SSL (Secure Socket Layer) with 128-bit encryption, which prevents third parties from reading your data illegally. If the encryption is not active, you should consider carefully whether you still want to send sensitive information over the Internet.
                        For this reason we recommend our users in this case to replace the sent password with a new personal password. You can change your password at any time in "elakiyaabestjobs.com" under "Change Password". We only store personal data that you enter in "elakiyaabestjobs.com". No other peson-related data is stored.
                        To ensure that your personal data receives adequate levels of protection, we have implemented appropriate measures with third parties with whom we share your personal data in order to ensure that your personal data is obtained from these third parties in a consistent manner with data protection which is consistent with data protection laws.
                    </div>

                    <div>
                        <span style={{ fontWeight: 'Bold' }}>QUESTIONS AND CONTACT INFORMATION:</span>
                    </div>
                    <div>
                        If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at <span style={{ fontWeight: 'Bold' }}>{emailid1} </span> or by mail at <span style={{ fontWeight: 'Bold' }}>{place} </span>
                    </div>
                </p>
                <div style={{ textAlign: 'center' }}>
                    <button className="btn btn-primary" style={{ background: 'blue' }}>
                        <Link to='/' style={{ color: 'white', textDecoration: 'none' }}>Back</Link></button>
                </div>
            </div>
        </div>
    )
}

